import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:w-[640px] min-h-screen w-full" }
const _hoisted_2 = ["src"]

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeModal',
  setup(__props) {

const noticeList = [
    {
        id : 1,
        title : '공지 / 파충류 다 있다 이용 수칙 안내',
        link : 'https://pada.s3.ap-northeast-2.amazonaws.com/paper/html/virgin.html',
        created_at : '2023-10-06T09:05:04.000Z'
    },
    {
        id : 2,
        title : '공지 / 커뮤니티 신고 처리 방침',
        link : 'https://pada.s3.ap-northeast-2.amazonaws.com/paper/html/hongkong_1.html',
        created_at : '2023-10-06T09:05:04.000Z'
    },
]

const store = useStore();
const route = useRoute();

const postUrl = computed(() => store.state.columnNewsUrl);


// 선택된 게시물에 대한 computed 속성
const selectedPost = computed(() => {
    const index = Number(route.params.id); // route.params.id를 숫자로 변환
    return noticeList.find(data => data.id === index);
});

// selectedPost의 변경사항을 감시하고, 해당 게시물의 htmlLink1 값을 SET_COLUMN_URL 커밋으로 저장
watch(selectedPost, (newVal) => {
    if (newVal && newVal.link) {
        store.commit('SET_COLUMN_URL', newVal.link);
    }
}, { immediate: true }); // immediate: true 옵션으로 컴포넌트 마운트 시 즉시 실행




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      id: "imported-content",
      src: postUrl.value,
      width: "100%",
      height: "100%",
      frameborder: "0",
      style: {"height":"100vh"}
    }, null, 8, _hoisted_2)
  ]))
}
}

})